import { useTranslation } from 'react-i18next';

import type { AuctionQuestionStatus, AuctionSaleStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const SUCCESS = 'bg-success/15 text-success border-transparent dark:bg-success/20';
const NEUTRAL = 'border-border text-muted-foreground';
const INFO = 'bg-primary/10 text-foreground border-transparent';
const WARNING = 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25';
const DANGER = 'bg-destructive/10 text-destructive border-transparent';

const SALE: Record<AuctionSaleStatus, string> = {
  draft: NEUTRAL,
  scheduled: INFO,
  live: SUCCESS,
  ended: NEUTRAL,
  cancelled: DANGER,
};

const QUESTION: Record<AuctionQuestionStatus, string> = {
  pending: WARNING,
  answered: SUCCESS,
  hidden: NEUTRAL,
};

export function SaleStatusBadge({
  status,
  className,
}: {
  status: AuctionSaleStatus;
  className?: string;
}) {
  const { t } = useTranslation('auctions');
  return (
    <Badge variant="outline" className={cn(SALE[status], className)}>
      {status === 'live' ? (
        <span aria-hidden className="bg-success size-1.5 animate-pulse rounded-full" />
      ) : null}
      {t(`sales.status.${status}`)}
    </Badge>
  );
}

export function QuestionStatusBadge({
  status,
  className,
}: {
  status: AuctionQuestionStatus;
  className?: string;
}) {
  const { t } = useTranslation('auctions');
  return (
    <Badge variant="outline" className={cn(QUESTION[status], className)}>
      {t(`questions.status.${status}`)}
    </Badge>
  );
}
